module.exports = "<ng-template #layout></ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layoutResolver.component.html
// module id = ./src/app/views/presentations/layouts/layoutResolver.component.html
// module chunks = main